<template>
  <div class="page">
    <div class="content-center">
      <!-- 步骤条 -->
      <div class="steps">
        <div class="step-item bright">
          <div class="step-item-num">1</div>
          <div class="step-item-title">填写供应商信息</div>
        </div>
        <div class="step-item">
          <div class="step-item-num">2</div>
          <div class="step-item-title">提交审核</div>
        </div>
        <div class="step-item">
          <div class="step-item-num">3</div>
          <div class="step-item-title">注册成功</div>
        </div>
      </div>
      <!-- 表单录入 -->
      <el-form ref="ruleForm" :model="entity" :rules="rules" label-width="auto">
        <div class="form-card">
          <div class="form-card-title">供应商信息</div>
          <div class="form-card-body">
            <el-form-item label="供应商名称:" prop="name">
              <el-input v-model="entity.name" placeholder="请输入" maxlength="50" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="供应商类别:" prop="category">
              <el-select v-model="entity.category" value-key="id" placeholder="请选择供应商类别" @change="handleSelectChange('category', $event)" multiple>
								<el-option v-for="item in options.categoryList" :value="item" :label="item.label" :key="item.id"></el-option>
							</el-select>
            </el-form-item>
            <el-form-item label="纳税人性质:" prop="taxpayerNature">
							<el-select v-model="entity.taxpayerNature" placeholder="请选择">
								<el-option v-for="item in options.taxpayerNatureList" :key="item.id" :label="item.label" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
            <el-form-item label="供应商用途:" prop="supplierPurposes">
							<el-select v-model="entity.supplierPurposes" placeholder="请选择" multiple>
								<el-option v-for="item in options.supplierPurposeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
            <el-form-item label="企业性质:" prop="companyNature">
							<el-radio-group v-model="entity.companyNature">
								<el-radio v-for="item in options.companyNatureList" :label="item.value" :key="item.id">{{ item.label }}</el-radio>
							</el-radio-group>
						</el-form-item>
            <el-form-item label="注册资金:" prop="registeredCapital">
              <el-input
								v-model="entity.registeredCapital"
								@input="value => entity.registeredCapital = value.replace(/[^\d]/g, '')"
								placeholder="0.00"
								show-word-limit
								clearable
							>
                <template #suffix>万元</template>
              </el-input>
						</el-form-item>
            <div style="display: flex;">
              <el-form-item label="营业期限:" prop="businessTerm" style="flex: 1;">
                <el-select v-model="entity.businessTerm" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in options.businessTermList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="entity.businessTerm === 'FixedTerm'" prop="businessDateRange" label-width="10px">
                <date-range-picker v-model="entity.businessDateRange"></date-range-picker>
              </el-form-item>
            </div>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item label="供应商经营地:" prop="provinceId">
                  <el-select v-model="entity.provinceId" @change="handleSelectChange('provinceId', $event)" placeholder="请选择省" clearable filterable>
                    <el-option v-for="item in options.province" :value="item.id" :label="item.name" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item prop="cityId" ref="cityFormItem" label-width="0px">
                  <el-select v-model="entity.cityId" placeholder="请选择市" :disabled="!entity.provinceId" clearable filterable>
                    <el-option v-for="item in options.city" :value="item.id" :label="item.name" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="detailedAddress" label-width="0px">
                  <el-input placeholder="请输入详细地址" v-model="entity.detailedAddress" maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="经营范围:" prop="operationScope">
							<el-input v-model="entity.operationScope" type="textarea" maxlength="500" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="备注:" prop="remark">
              <el-input v-model="entity.remark" type="textarea" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="代理/授权证书:" prop="proxyCertificate">
              <el-input v-model="entity.proxyCertificate" type="textarea" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">产品系统</div>
          <div class="form-card-body">
            <el-form-item label="标签:" prop="productSubsystems">
							<el-checkbox-group v-model="entity.productSubsystems">
								<el-checkbox v-for="item in options.subSystemList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
            <el-form-item label="其他系统:" prop="subsystemRemark" v-if="entity.productSubsystems.includes('1530364732841283586')">
              <el-input v-model="entity.subsystemRemark" placeholder="请输入系统名称"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">开票资料</div>
          <div class="form-card-body">
            <el-form-item label="开户银行:" prop="invoiceInfo.openingBank">
              <el-input v-model="entity.invoiceInfo.openingBank" placeholder="请输入" maxlength="100" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="发票抬头:" prop="invoiceInfo.name">
              <el-input v-model="entity.invoiceInfo.name" placeholder="请输入" maxlength="100" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="银行账号:" prop="invoiceInfo.bankAccount">
              <el-input v-model="entity.invoiceInfo.bankAccount" placeholder="请输入" maxlength="100" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="税务登记号:" prop="invoiceInfo.taxpayerNumber">
							<el-input v-model="entity.invoiceInfo.taxpayerNumber" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="电话:" prop="invoiceInfo.telephone">
							<el-input
								v-model="entity.invoiceInfo.telephone"
								@input="value => entity.invoiceInfo.telephone = value.replace(/[^\d]/g, '')"
								placeholder="请输入"
								maxlength="50"
								show-word-limit
								clearable
							></el-input>
						</el-form-item>
            <el-form-item label="地址:" prop="invoiceInfo.address">
							<el-input v-model="entity.invoiceInfo.address" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
            <el-form-item label="是否接受银行承兑:" prop="invoiceInfo.draft">
							<el-radio-group v-model="entity.invoiceInfo.draft">
								<el-radio :label="true">是</el-radio>
								<el-radio :label="false">否</el-radio>
							</el-radio-group>
						</el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">企业资料</div>
          <div class="form-card-body">
            <el-form-item label="营业执照:" prop="businessLicenseUrl">
							<el-upload
								:action="uploadUrl"
                accept=".jpg,.png"
								list-type="picture-card"
								:on-preview="fileOnPreview"
								:on-remove="(file, fileList) => fileOnRemove(file, fileList, 'businessLicenseUrl')"
								:before-upload="fileBeforeUpload"
								:on-success="(response, file, fileList) => fileUploadSuccess('businessLicenseUrl', response, file)"
								:limit="1"
							>
								<div class="el-upload-item"><div class="position-relative">上传营业执照</div></div>
							</el-upload>
							<div class="el-upload__tip">请上传本地图片，大小不超过5M，并且为jpg或png格式，图片清晰。</div>
						</el-form-item>
            <el-form-item label="分包资料:" prop="subcontractDataUrl">
							<el-upload
								:action="uploadUrl"
                accept=".jpg,.png"
								list-type="picture-card"
								:on-preview="fileOnPreview"
								:on-remove="(file, fileList) => fileOnRemove(file, fileList, 'subcontractDataUrl')"
								:before-upload="fileBeforeUpload"
								:on-success="(response, file, fileList) => fileUploadSuccess('subcontractDataUrl', response, file)"
								:limit="1"
							>
								<div class="el-upload-item"><div class="position-relative">上传分包资料</div></div>
							</el-upload>
						</el-form-item>
            <el-form-item label="代理文件:" prop="proxyFileUrl">
							<el-upload
								:action="uploadUrl"
                accept=".jpg,.png"
								list-type="picture-card"
								:on-preview="fileOnPreview"
								:on-remove="(file, fileList) => fileOnRemove(file, fileList, 'proxyFileUrl')"
								:before-upload="fileBeforeUpload"
								:on-success="(response, file, fileList) => fileUploadSuccess('proxyFileUrl', response, file)"
								:limit="1"
							>
								<div class="el-upload-item"><div class="position-relative">上传代理文件</div></div>
							</el-upload>
						</el-form-item>
            <el-form-item label="开户许可证:" prop="openAccountUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('openAccountUrl', list)"
								:on-remove="(file, list) => uploadChange('openAccountUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
            <el-form-item label="公司介绍:" prop="companyUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('companyUrl', list)"
								:on-remove="(file, list) => uploadChange('companyUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
            <el-form-item label="产品介绍:" prop="productUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('productUrl', list)"
								:on-remove="(file, list) => uploadChange('productUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
            <el-form-item label="资质文件:" prop="credentialUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('credentialUrl', list)"
								:on-remove="(file, list) => uploadChange('credentialUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
            <el-form-item label="解决方案:" prop="schemeUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('schemeUrl', list)"
								:on-remove="(file, list) => uploadChange('schemeUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
            <el-form-item label="其他:" prop="otherUrl">
							<el-upload
								:action="uploadUrl"
								:limit="1"
								:before-upload="beforeUpload"
								:on-success="(res, file, list) => uploadChange('otherUrl', list)"
								:on-remove="(file, list) => uploadChange('otherUrl', list)"
							>
								<el-button stopCountDown>上传附件</el-button>
								<span slot="tip" class="el-upload__tip ml-10">文件大小不能超过10MB</span>
							</el-upload>
						</el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">协议信息</div>
          <div class="form-card-body">
            <el-form-item label="平台协议签约:" prop="agreementUrl">
              <el-upload
								:action="uploadUrl"
								accept=".pdf"
								:limit="1"
								:before-upload="beforePdfUpload"
								:on-success="(res, file, list) => uploadChange('agreementUrl', list)"
								:on-remove="(file, list) => uploadChange('agreementUrl', list)"
							>
								<el-button stopCountDown>上传协议</el-button>
								<el-button type="text" @click.stop="downloadTemplate">下载模板</el-button>
								<span slot="tip" style="margin-left: 10px;">只能上传pdf，且不超过10MB</span>
							</el-upload>
						</el-form-item>
          </div>
        </div>
        <div class="form-card">
          <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane name="detailList">
              <template slot="label">
                <span class="tab-title">联系人</span>
              </template>
              <detail-list ref="detailList" editable></detail-list>
            </el-tab-pane>
            <el-tab-pane name="document">
              <template slot="label">
                <span class="tab-title">附件</span>
              </template>
              <attachments-viewer ref="attachments" editable height="100%"></attachments-viewer>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-form>
    </div>
    <div class="action-bar">
      <div class="primary-btn" @click="submitForm('ruleForm')">提交</div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
			<el-image :src="dialogImageUrl" class="flex-sub" fit="contain">
				<div slot="error" class="image-slot text-xsl"><i class="el-icon-picture-outline"></i></div>
			</el-image>
		</el-dialog>
    <!-- 流程弹窗 -->
    <send-workflow ref="sendWorkFlow" save></send-workflow>
  </div>
</template>

<script>
import { getCurrentUser } from '@/api/home/home.js';
import {
  getByEnumClass,
  getSubsystem,
  getByDictKey,
  brandQuery,
  queryProvinceList,
  queryCityList,
  supplierAddModel
} from '@/api/supplier/index.js';
import SupplierAuthApi from '@/api/supplier/supplierAuthApi';
import { verificationBlank, isEmpty } from '@/utils';

import dateRangePicker from '@/components/date-range-picker';
import attachmentsViewer from '@/components/attachments/attachments-viewer.vue';
import detailList from './components/detailList.vue';
import sendWorkflow from '@/components/workflow/sendWorkflow.vue';

export default {
  components: {
    dateRangePicker,
    attachmentsViewer,
    detailList,
    sendWorkflow
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_URL + 'longstron/base/doc/file/upload',
			entity: {
				supplierProductSystemCrudRows: {
					//联系人
					//清单
					added: []
				}, // 产品信息数据
				creationDate: new Date(), //创建时间
				name: '', //供应商名称
				category: [], // 供应商类别
				categoryIds: [], //供应商类别id
				taxpayerNature: 'COMMONTAXPAYER', //纳税人性质
				supplierPurposes:[], //供应商用途数组
				supplierPurpose: '', //供应商用途
				provinceId: null, //省id
				cityId: null, //市id
				detailedAddress: '', //详细地址
				registeredCapital: '', //注册资金
				paymentDays: '', //账期
				supplyCycle: '', //供货周期
				companyNature: 'Private', //企业性质
				businessTerm: 'FixedTerm', //营业期限类型
				businessStartDate: '', //营业开始日期
				businessDate: '', //营业结束日期
				businessDateRange: [], //营业日期范围
				productSubsystems: [], //产品系统
        subsystemRemark: '', // 其他系统
				operationScope: '', //经营范围
				remark: '', //备注
				sfjsyhcd: true, // 是否接受银行承兑
        proxyCertificate: '', // 代理/授权证书
				businessLicenseUrl: '', //营业执照
				subcontractDataUrl: '', //分包资料
				proxyFileUrl: '', //代理文件
				openAccountUrl: '', //开户许可证
				companyUrl: '', //公司介绍
				productUrl: '', //产品介绍
				credentialUrl: '', //资质文件
				schemeUrl: '', //解决方案
				otherUrl: '', //其他
				agreementUrl: '', //平台协议签约
				invoiceInfo: {
					//开票信息
					openingBank: '', //开户银行
					name: '', //账户名称
					bankAccount: '', //账号
					taxpayerNumber: '' ,//税务登记号
					telephone: '', //电话
					address: '', //地址
					draft: '', //是否接受汇票
				},
				supplierLinkmanCrudRows: {
					//联系人
					//清单
					added: []
				}
			},
			activeTab: 'detailList', // 当前激活标签页
			currentUser: {}, //当前用户
			dialogImageUrl: '', // 附件预览地址
			dialogVisible: false, // 是否预览图片
			// 选择类数据
			options: {
				categoryList: [], //供应商类别
				taxpayerNatureList: [], //纳税人性质
				supplierPurposeList: [], //供应商用途
				companyNatureList: [], //企性质
				businessTermList: [], //营业期限类型
				subSystemList: [], //包含子系统
				province: [], // 省
				city: [] ,// 市
				brandList: [], //品牌列表
			},
			rules: {
				name: [{ required: true, message: '请输入供应商名称' }, { validator: verificationBlank }],
				category: [{ required: true, message: '请选择供应商类别' }],
				taxpayerNature: [{ required: true, message: '请选择纳税人性质' }],
				provinceId: [{ required: true, message: '请选择省' }],
				cityId: [{ required: true, message: '请选择市' }],
				detailedAddress: [{ required: true, message: '请填写详细信息' }],
				supplierPurposes: [{ required: true, message: '请选择供应商用途', trigger: 'blur' }],
				companyNature: [{ required: true, message: '请选择企业性质' }],
				registeredCapital: [{ required: true, message: '请输入注册资金' }],
				businessTerm: [{ required: true, message: '请选择营业期限' }],
				businessDateRange: [{
          validator: (rule, value, callback) => {
            if(isEmpty(value[0]) || isEmpty(value[1])) {
              callback(new Error('请选择营业日期范围'));
            } else {
              callback();
            }
          }
        }],
				operationScope: [{ required: true, message: '请选择经营范围' }],
				'invoiceInfo.openingBank': [{ required: true, message: '请输入开户银行' }],
				'invoiceInfo.name': [{ required: true, message: '请输入发票抬头' }],
				'invoiceInfo.bankAccount': [{ required: true, message: '请输入账号' }],
				'invoiceInfo.taxpayerNumber': [{ required: true, message: '请输入税务登记号' }],
				'invoiceInfo.telephone': [{ required: true, message: '请输入电话' }],
				'invoiceInfo.address': [{ required: true, message: '请输入地址' }],
				productSubsystems: [{ required: true, message: '请选择产品系统' }],
				businessLicenseUrl: [{ required: true, message: '请上传营业执照' }],
        // agreementUrl: [{ required: true, message: '请上传平台协议' }]
			},
			detailList: {
				dataList: [],
				loading: false, // 是否局部加载
				multipleSelection: [], // 选中项
				removed: [], // 删除项清单
				model: {
					linkmanName: '', // 联系人名称
					linkmanJob: '', // 联系人职务
					linkmanTelephone: '', // 联系人电话
					remark: '' // 备注
				}
			},
      workflow: {
				title: '',
				baseUrl: '/longstron/material/supplier/certification',
				permissionCode: 'purchase0409',
				commitWorkflow: true,
				entityCode: null, // 实体code
				entityId: null ,// 实体id
				projectId: null, // 项目id
				projectName: null // 项目名称
			}
    }
  },
	created() {
		//获取当前用户
		this.getCurrentUser();
		// 获取枚举类数据
		this.getEnumData(['TaxpayerNatureEnum', 'SupplierPurposeEnum', 'CompanyNatureEnum', 'BusinessTermEnum']);
		//获取供应商类别列表
		this.getSupplierCategoryList('MaterialSupplier');
		//获取省数据
		this.getProvinceList();
		//获取子系统列表
		this.getSubsystemList();
		//获取品牌列表
		this.getBrandList();
	},
  methods: {
		/**
		 * @description: 获取当前用户
		 */
		getCurrentUser() {
			getCurrentUser().then(user => {
				if (user) this.currentUser = user;
			});
		},
		/**
		 * @description 获取枚举类数据
		 * @param {Array} enumClass 枚举类类名
		 */
		getEnumData(enumClass) {
			getByEnumClass(enumClass).then(res => {
				if (res != null && res.code === '00000') {
					this.options.taxpayerNatureList = res.model.TaxpayerNatureEnum;
					this.options.supplierPurposeList = res.model.SupplierPurposeEnum;
					this.options.companyNatureList = res.model.CompanyNatureEnum;
					this.options.businessTermList = res.model.BusinessTermEnum;
				}
			});
		},
		/**
		 * @description 获取子系统
		 */
		getSubsystemList() {
			getSubsystem().then(res => {
				if (res != null && res.code === '00000') {
					this.options.subSystemList = res.rows;
				}
			});
		},
		/**
		 * @description: 获取供应商类别列表
		 */
		getSupplierCategoryList(dictKey) {
			getByDictKey(dictKey).then(res => {
				if (res != null && res.code === '00000') {
					this.options.categoryList = res.rows;
				}
			});
		},
		/**
		 * @description: 获取品牌列表
		 */
		getBrandList() {
			brandQuery({ pagination: false }).then(res => {
				if (res != null && res.code === '00000') {
					this.options.brandList = res.rows;
				}
			});
		},
		/**
		 * @description: 选择框变更
		 * @param {String} field 对应字段
		 * @param {Object} value 变更值
		 */
		handleSelectChange(field, value) {
			switch (field) {
				case 'category':
					this.entity.categoryIds = value.map(obj => obj.id);
					break;
				case 'provinceId':
					this.getCityList(value);
					this.$refs['cityFormItem'].resetField();
					break;
			}
		},
		/**
		 * @description: 获取省列表数据
		 */
		getProvinceList() {
			queryProvinceList().then(res => {
				if (res && res.code === '00000') {
          res.rows.shift();
					this.options.province = res.rows;
				}
			});
		},
		/**
		 * @description: 根据省id获取市列表数据
		 * @param {String} provinceId 省列表
		 */
		getCityList(provinceId) {
			queryCityList(provinceId).then(res => {
				if (res && res.code === '00000') {
					this.options.city = res.rows;
				}
			});
		},
		/**
		 * @description: 附件上传前效验
		 * @param {File} file 附件
		 */
		fileBeforeUpload(file) {
			let isJPG = file.type === 'image/jpeg';
			let isPNG = file.type === 'image/png';
			let isLt5M = file.size / 1024 / 1024 < 5;

			if (!isJPG && !isPNG) {
				this.$message.error('上传图片只能是 JPG/PNG 格式!');
			} else if (!isLt5M) {
				this.$message.error('上传图片大小不能超过 5MB!');
			}
			return (isJPG || isPNG) && isLt5M;
		},
		/**
		 * @description: 附件上传成功后的回调
		 * @param {Oject} res 附件上传接口返回值
		 * @param {File} file 附件
		 * @param {Array} fileList 附件列表
		 */
		fileUploadSuccess(url, res, file) {
			this.$message.success('上传成功！');
			this.entity[url] = res.model.httpFilePath;
		},
		/**
		 * @description: 附件预览
		 * @param {File} file 附件
		 */
		fileOnPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
    beforePdfUpload(file) {
			const isPdf = file.type === 'application/pdf';
			const isLt5M = file.size / 1024 / 1024 < 10;
			if (!isPdf) {
				this.$message.error('只能上传PDF文件!');
				return false;
			}
			if (!isLt5M) {
				this.$message.error('文件大小不能超过 10MB!');
				return false;
			}
			return true;
		},
    beforeUpload(file) {
			const isLt10M = file.size / 1024 / 1024 < 10;
			if (!isLt10M) {
				this.$message.error('文件大小不能超过 10MB!');
				return false;
			}
			return true;
		},
		uploadChange(field, list) {
			this.entity[field] = list.map(v => v.uid ? v.response?.model?.httpFilePath : v.url).join(',');
		},
		downloadTemplate() {
			const url = 'https://longstron.oss-cn-shanghai.aliyuncs.com/2026/01/21/15/6ff5e24b14244fa29e01c371a6e3f459.docx';
			const link = document.createElement('a');
			link.style.display = 'none';
			// 设置下载地址
			link.setAttribute('href', url);
      link.setAttribute('target', '_blank');
			// 设置文件名
			link.setAttribute('download', '合作协议模板.docx');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		/**
		 * @description: 附件删除
		 * @param {File} file 附件
		 * @param {Array} fileList 附件列表
		 * @param {String} field 对应字段
		 */
		fileOnRemove(file, fileList, field) {
			this.entity[field] = null;
		},
		handleInputSelect(item) {
			this.entity.invoiceInfo.name = item.name;
			this.entity.invoiceInfo.openingBank = item.bankName;
			this.entity.invoiceInfo.bankAccount = item.bankAccount;
		},
		/**
		 * @description: 更改选中项
		 * @param {String} tableName 表格名称
		 * @param {Array} selection 选中项
		 */
		handleSelectionChange(tableName, selection) {
			this[tableName].multipleSelection = selection;
		},
		/**
		 * @description: 标签页被选中时
		 * @param {Object} tab 被选中的标签实例
		 */
		handleTabClick(tab) {
			switch (tab.name) {
				case 'detailList':
					// 新增
					if (this.entity.detailList == null || this.entity.detailList.length === 0) {
						this.handleAddRow('detailList');
					}
					// 详情
					// if (this.entity.detailList == null) {
					// 	this.getDetailList(this.entity.id, true);
					// }
					break;
				default:
					break;
			}
		},
		/**
		 * @description: 点击表格行
		 * @param {String} tableName 表格名称
		 * @param {Objject} row 选中行
		 */
		handleRowClick(tableName, row) {
			if (row.insertType !== 'ADD') {
				row.insertType = 'EDIT';
			}
			this.$refs[tableName].clearSelection();
			this.$refs[tableName].toggleRowSelection(row);
		},
		/**
		 * @description: 指定表格新增一行
		 * @param {String} tableName 表格名称
		 */
		handleAddRow(tableName) {
			let model = {
				insertType: 'ADD'
			};
			this[tableName].dataList.push(Object.assign(model, this[tableName].model));
		},
		/**
		 * @description: 指定表格批量删除
		 * @param {String} tableName 表格名称
		 */
		handleDeleteRows(tableName) {
			this[tableName].multipleSelection.sort((a, b) => {
				return b.rowIndex - a.rowIndex;
			});
			for (let i = 0, len = this[tableName].multipleSelection.length; i < len; i++) {
				let row = this[tableName].multipleSelection[i];
				if (row.insertType !== 'ADD') {
					this[tableName].removed.push(row);
				}
				this.entity[tableName].splice(row.rowIndex, 1);
			}
		},
		/**
		 * @description: 提交保存新增
		 */
		submitForm(formName) {
			this.entity.supplierPurpose = this.entity.supplierPurposes.join(',');
			Promise.all([this.$refs[formName].validate(), this.$refs['detailList'].validate()]).then(vaild => {
				this.entity.businessStartDate = this.entity.businessDateRange[0];
				this.entity.businessDate = this.entity.businessDateRange[1];
				this.entity.attachments = this.$refs['attachments'].getStoreRows();
				this.entity.supplierLinkmanCrudRows = this.$refs['detailList'].getStoreRows();
				SupplierAuthApi.addModel(this.entity).then(res => {
					if (res != null && res.code == '00000') {
						this.$message.success('保存成功！');
						this.$router.push('./submitted');
					}
				});
        /* this.workflow.title = `供应商认证-${this.entity.name}`;
        this.$refs['sendWorkFlow'].openWorkflowDialog(this.workflow, this.entity, () => {
          this.$router.push('./submitted');
        }); */
			});
		},
	}
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 48px;
  .steps {
    height: 74px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    .step-item {
      display: flex;
      align-items: center;
      + .step-item {
        margin-left: 160px;
        position: relative;
        &::before {
          content: '';
          width: 128px;
          height: 1px;
          background-image: linear-gradient(to right, #C4C4C4 0%, #C4C4C4 50%, transparent 50%, transparent 50%);
          background-size: 10px 100%;
          position: absolute;
          left: -16px;
          top: 50%;
          transform: translate(-100%, -50%);
        }
      }
      .step-item-num {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        border-radius: 50%;
        background-color: #EDEFF2;
        color: #979EA5;
        line-height: 24px;
        text-align: center;
      }
      &.bright {
        .step-item-num {
          background-color: @primary-color;
          color: #fff;
        }
        .step-item-title {
          font-family: @font-medium;
          color: @default-color;
        }
      }
    }
  }

  .form-card {
    margin-top: 24px;
    padding: 24px 32px;
    background-color: #fff;
    border-radius: 4px;
    .form-card-title {
      padding-bottom: 20px;
      font-family: @font-medium;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .required::after {
        content: '*';
        color: red;
        margin-left: 4px;
      }
    }
    .form-card-body {
      width: 70%;
      margin: 0 auto;
      .el-select,
      .el-input-number {
        width: 100%;
      }
      :deep(.el-form-item__label) {
        font-family: @font-medium;
        color: @default-color;
      }
    }
  }

  .action-bar {
    margin-top: 48px;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px -4px 15px 0px rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    .primary-btn {
      width: 185px;
      height: 49px;
    }
  }
}

.tab-title {
  font-weight: bold;
}

.el-upload__tip {
  // margin-top: 0px;
  font-size: 14px;
  line-height: 22px;
}
.ml-10 {
  margin-left: 10px;
}

:deep(.el-upload--picture-card) {
  width: 110px !important;
  height: 110px !important;
  line-height: 108px;
}
:deep(.el-upload-list--picture-card) {
  margin-bottom: -8px;
  display: inline-flex;
  .el-upload-list__item {
    width: 110px !important;
    height: 110px !important;
  }
}
</style>
